import React, { Component } from "react";
import * as d3 from "d3";
import styled from "styled-components";

const Container = styled.div`
  text-align: right;
  display: ${props => (props.show ? "inherit" : "none")};
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.span`
  font-family: "dubai-bold";
  font-size: 11px;
  color: ${props => props.theme.textHighlight};

  @media (min-width: 1800px) {
    font-size: 17px;
  }
`;

const Value = styled.span`
  font-family: "dubai-medium";
  font-size: 17px;
  color: ${props => props.theme.textHighlight};

  @media (min-width: 1800px) {
    font-size: 28px;
    margin-top: 15px;
  }
`;

const Graph = styled.div`
  margin-top: 20px;

  text {
    fill: ${props => props.theme.textHighlight};
    font-size: 10px;

    @media (min-width: 1800px) {
      font-size: 15px;
    }
  }
  .base {
    stroke-width: 0.5px;
      stroke-dasharray: 2, 2;

    @media (min-width: 1800px) {
      stroke-width: 2px;
      stroke-dasharray: 3, 4;
    }
  }
`;

class SmallAreaGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name: "نسبة سعادة المتعاملين",
        value: 92,
        smallGraphGradient: ["#A0E9FF", "#33CCCC"],
        plotData: [
          {
            date: "1-May-12",
            close: 100
          },
          {
            date: "30-Apr-12",
            close: 40
          },
          {
            date: "27-Apr-12",
            close: 60
          },
          {
            date: "26-Apr-12",
            close: 10
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.drawGraph();
  }

  drawGraph = () => {
    const { plotData, smallGraphGradient } = this.state.data;
    let containerWidth = 180,
      containerHeight = 60,
      basePointRadius = 2,
      margin = { top: 2, right: 2, bottom: 20, left: 2 };

    if (window.innerWidth > 1800) {
      containerWidth = 300;
      containerHeight = 110;
      basePointRadius = 4;
      margin = { top: 5, right: 5, bottom: 35, left: 5 };
    }

    // set the dimensions and margins of the graph
    let width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom;

    const cfg = {
      margin,
      width,
      height,
      basePointRadius
    };

    // parse the date / time
    let parseTime = d3.timeParse("%d-%b-%y");

    // set the ranges
    let x = d3.scaleTime().range([0, width]);
    let y = d3.scaleLinear().range([height, 0]);

    // scale the range of the data
    x.domain(
      d3.extent(plotData, function(d) {
        return parseTime(d.date);
      })
    );
    y.domain([
      0,
      d3.max(plotData, function(d) {
        return d.close;
      })
    ]);

    // define the area
    let area = d3
      .area()
      .curve(d3.curveMonotoneX)
      .x(function(d) {
        return x(parseTime(d.date));
      })
      .y0(height)
      .y1(function(d) {
        return y(d.close);
      });

    // define the line
    var valueline = d3
      .line()
      .curve(d3.curveMonotoneX)
      .x(function(d) {
        return x(parseTime(d.date));
      })
      .y(function(d) {
        return y(d.close);
      });

    let svg = d3
      .select(this.graph)
      .append("svg")
      .attr("width", cfg.width + cfg.margin.left + cfg.margin.right)
      .attr("height", cfg.height + cfg.margin.top + cfg.margin.bottom)
      .attr(
        "viewbox",
        `0 0 ${cfg.width + cfg.margin.left + cfg.margin.right} ${cfg.height +
          cfg.margin.top +
          cfg.margin.bottom}`
      )
      .append("g")
      .attr(
        "transform",
        "translate(" + cfg.margin.left + "," + cfg.margin.top + ")"
      );

    ///////////////////////////////////////////////////
    ///////////// Create the linear gradient //////////
    ///////////////////////////////////////////////////

    svg
      .append("defs")
      .append("linearGradient")
      .attr("id", "linear-gradient")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", 0)
      .attr("y1", y(0))
      .attr("x2", 0)
      .attr("y2", y(100))
      .selectAll("stop")
      .data([
        { offset: "0%", color: smallGraphGradient[0] },
        { offset: "100%", color: smallGraphGradient[1] }
      ])
      .enter()
      .append("stop")
      .attr("offset", function(d) {
        return d.offset;
      })
      .attr("stop-color", function(d) {
        return d.color;
      });

    // add the area
    svg
      .append("path")
      .data([plotData])
      .attr("class", "area-small")
      .attr("d", area)
      .style("fill", "url(#linear-gradient)");

    // add the valueline path.
    svg
      .append("path")
      .data([plotData])
      .attr("class", "line-small")
      .attr("d", valueline)
      .style("stroke", smallGraphGradient[1])
      .style("fill", "none");

    // Line joining base of 1st and last value

    let first = plotData[0].close;
    let last = plotData[plotData.length - 1].close;

    svg
      .append("line")
      .attr("x1", 0)
      .attr("y1", y(0))
      .attr("x2", 0)
      .attr("y2", y(last))
      .style("stroke", smallGraphGradient[1])
      .style("fill", "none");

    svg
      .append("line")
      .attr("x1", cfg.width)
      .attr("y1", y(0))
      .attr("x2", cfg.width)
      .attr("y2", y(first))
      .style("stroke", smallGraphGradient[1])
      .style("fill", "none");

    //Circles at two ends of axes
    svg
      .append("circle")
      .attr("cx", 0)
      .attr("cy", y(0))
      .attr("r", cfg.basePointRadius)
      .style("fill", smallGraphGradient[1]);

    svg
      .append("circle")
      .attr("cx", cfg.width)
      .attr("cy", y(0))
      .attr("r", cfg.basePointRadius)
      .style("fill", smallGraphGradient[1]);

    //Dashed line in the base
    svg
      .append("line")
      .attr("x1", 0)
      .attr("y1", y(0))
      .attr("x2", cfg.width)
      .attr("y2", y(0))
      .attr("class", "base")
      .style("stroke", smallGraphGradient[1])
      .style("fill", "none");

    // text below the graph
    svg
      .append("text")
      .attr("text-anchor", "start")
      .attr("x", 0)
      .attr("y", y(-40))
      .attr("class", "smallgraph-marking")
      .text("2019");

    svg
      .append("text")
      .attr("text-anchor", "end")
      .attr("x", width)
      .attr("y", y(-40))
      .attr("class", "smallgraph-marking")
      .text("2018");
  };
  render() {
    const { name, value } = this.state.data;
    const { show } = this.props;
    return (
      <Container show={show}>
        <Data>
          <Name>{name}</Name>
          <Value>{value}%</Value>
        </Data>
        <Graph ref={el => (this.graph = el)} className="smallGraph" />
      </Container>
    );
  }
}

export default SmallAreaGraph;
